module.exports = __webpack_public_path__ + "img/0-75.139250dc.jpg";